import React from "react";
import Footer from "../Footer";

const RefundAndCancellationPolicy = (props) => {
  return (
    <>
      <div style={containerStyle}>
        <h1 style={headingStyle}>Refund and Order Cancellation Policy</h1>

        <h2 style={subHeadingStyle}>Order Cancellation Policy</h2>
        <p style={textStyle}>
          At Kiko Live, the cancellation policies for orders may differ based on
          the seller’s terms and conditions.
        </p>
        <p style={textStyle}>
          For sellers on the ONDC Network, certain products are marked as
          non-cancellable and non-returnable. These details will be clearly
          stated on the product’s page.
        </p>
        <p style={textStyle}>
          For orders eligible for cancellation, customers can cancel their
          purchases before they are dispatched. Once an order has been shipped,
          it cannot be canceled.
        </p>
        <p style={textStyle}>
          The cancellation window varies by category, and after a specified time
          period or status change, cancellations will no longer be permitted. If
          a customer attempts to cancel outside of this time frame, a
          cancellation fee may be applicable, depending on the product’s details
          on the product or order confirmation page. This time window is final.
        </p>
        <p style={textStyle}>
          If a seller cancels an order due to unforeseen reasons, a full refund
          will be processed for prepaid orders.
        </p>
        <p style={textStyle}>
          Kiko Live reserves the right to approve or reject any order
          cancellation. Additionally, Kiko Live may choose to modify or waive
          the time window or cancellation fee at its discretion.
        </p>

        <h2 style={subHeadingStyle}>Refund Policy</h2>
        <p style={textStyle}>
          The terms for refunds may differ depending on the seller’s policies
          and product category. Any specific refund guidelines mentioned on the
          product page will supersede general refund conditions.
        </p>
        <h3 style={subHeadingStyle}>Eligibility for Refunds:</h3>
        <ul style={listStyle}>
          <li>
            <strong>Non-Cancellable Products:</strong> Certain products, clearly
            indicated on the product page, cannot be canceled once ordered.
            Refunds for such items will only be granted if the product was not
            delivered or if the seller initiates a cancellation due to
            unforeseen circumstances.
          </li>
          <li>
            <strong>Cancellable Products:</strong> Refunds for cancellable items
            will be processed if the cancellation occurs before the product is
            shipped. Once the item is shipped, no cancellation or refund will be
            processed.
          </li>
          <li>
            <strong>Seller-Initiated Cancellations:</strong> If the seller
            cancels the order due to issues like stock unavailability or other
            unforeseen situations, a full refund will be issued for prepaid
            orders.
          </li>
        </ul>

        <h3 style={subHeadingStyle}>Refund Process</h3>
        <p style={textStyle}>
          <strong>Processing Time:</strong> Refunds will be initiated once the
          cancellation is confirmed or an issue is validated. Depending on the
          payment method used, the refund may take 5 to 7 business days to
          appear in the customer’s bank account.
        </p>
        <p style={textStyle}>
          <strong>Refund Method:</strong> Refunds will be credited to the same
          payment method used during the purchase.
        </p>

        <h2 style={subHeadingStyle}>General Terms</h2>
        <p style={textStyle}>
          Kiko Live retains the right to modify or waive any refund conditions
          at its discretion.
        </p>
        <p style={textStyle}>
          Any disputes or issues regarding refunds will be settled by Kiko Live,
          whose decision will be final.
        </p>
        <p style={textStyle}>
          For further queries or concerns about refunds, customers are
          encouraged to check the specific product page or contact Kiko Live
          customer support.
        </p>
      </div>
      <Footer />
    </>
  );
};

const containerStyle = {
  fontFamily: "Arial, sans-serif",
  margin: "20px auto",
  padding: "20px",
  maxWidth: "800px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const headingStyle = {
  textAlign: "center",
  color: "#333",
  marginBottom: "20px",
};

const subHeadingStyle = {
  color: "#444",
  margin: "15px 0 10px 0",
  fontSize: "18px",
  fontWeight: "bold",
};

const textStyle = {
  lineHeight: "1.6",
  color: "#555",
  marginBottom: "10px",
};
const listStyle = {
  marginLeft: "20px",
  color: "#555",
  lineHeight: "1.6",
};

export default RefundAndCancellationPolicy;
